// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

// Babel
require('core-js/stable');
require('regenerator-runtime/runtime');

// Modules
const navigationModule = require('../modules/navigation');


/**
 * Action Handlers
 */

function createActionHandlers() {

	// Handle press dashboard button
	$(document).on('click', '[name="scan-cta-button"]', () => {

		// Get current user
		const currentUser = Parse.User.current();

		// Perform action
		if (currentUser != null) {
			window.location = '/dashboard';
		} else if (process.env.ENTITY === 'keelerqik') {
			window.location = '/enroll/leader';
		} else {
			window.location = '/enroll/';
		}
	});
}


/**
 * Input Handlers
 */

function createInputHandlers() {}


/**
 * Init
 */

// Initialize navigation
navigationModule.initialize();

// Create action handlers
createActionHandlers();

// Create input handlers
createInputHandlers();
